"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.equals = exports.toStringInSpecifiedOrder = exports.setValues = exports.setText = exports.setInteger = exports.setAmount = exports.set = exports.removeProperty = exports.removeProperties = exports.merge = exports.map = exports.keepProperties = exports.isEmpty = exports.hasProperty = exports.getValuesOfType = exports.getValue = exports.getText = exports.getPropertyNames = exports.getInteger = exports.getAmount = exports.get = exports.fromProperty = exports.filter = exports.Empty = exports.count = void 0;
exports.fromString = fromString;
exports.fromStringOrError = fromStringOrError;
const uom_1 = require("@genesys/uom");
const property_1 = require("@promaster-sdk/property");
const PropertyCompare = __importStar(require("./property-compare"));
var property_value_set_1 = require("@promaster-sdk/property/lib/property-value-set");
Object.defineProperty(exports, "count", { enumerable: true, get: function () { return property_value_set_1.count; } });
Object.defineProperty(exports, "Empty", { enumerable: true, get: function () { return property_value_set_1.Empty; } });
Object.defineProperty(exports, "filter", { enumerable: true, get: function () { return property_value_set_1.filter; } });
Object.defineProperty(exports, "fromProperty", { enumerable: true, get: function () { return property_value_set_1.fromProperty; } });
Object.defineProperty(exports, "get", { enumerable: true, get: function () { return property_value_set_1.get; } });
Object.defineProperty(exports, "getAmount", { enumerable: true, get: function () { return property_value_set_1.getAmount; } });
Object.defineProperty(exports, "getInteger", { enumerable: true, get: function () { return property_value_set_1.getInteger; } });
Object.defineProperty(exports, "getPropertyNames", { enumerable: true, get: function () { return property_value_set_1.getPropertyNames; } });
Object.defineProperty(exports, "getText", { enumerable: true, get: function () { return property_value_set_1.getText; } });
Object.defineProperty(exports, "getValue", { enumerable: true, get: function () { return property_value_set_1.getValue; } });
Object.defineProperty(exports, "getValuesOfType", { enumerable: true, get: function () { return property_value_set_1.getValuesOfType; } });
Object.defineProperty(exports, "hasProperty", { enumerable: true, get: function () { return property_value_set_1.hasProperty; } });
Object.defineProperty(exports, "isEmpty", { enumerable: true, get: function () { return property_value_set_1.isEmpty; } });
Object.defineProperty(exports, "keepProperties", { enumerable: true, get: function () { return property_value_set_1.keepProperties; } });
Object.defineProperty(exports, "map", { enumerable: true, get: function () { return property_value_set_1.map; } });
Object.defineProperty(exports, "merge", { enumerable: true, get: function () { return property_value_set_1.merge; } });
Object.defineProperty(exports, "removeProperties", { enumerable: true, get: function () { return property_value_set_1.removeProperties; } });
Object.defineProperty(exports, "removeProperty", { enumerable: true, get: function () { return property_value_set_1.removeProperty; } });
Object.defineProperty(exports, "set", { enumerable: true, get: function () { return property_value_set_1.set; } });
Object.defineProperty(exports, "setAmount", { enumerable: true, get: function () { return property_value_set_1.setAmount; } });
Object.defineProperty(exports, "setInteger", { enumerable: true, get: function () { return property_value_set_1.setInteger; } });
Object.defineProperty(exports, "setText", { enumerable: true, get: function () { return property_value_set_1.setText; } });
Object.defineProperty(exports, "setValues", { enumerable: true, get: function () { return property_value_set_1.setValues; } });
Object.defineProperty(exports, "toString", { enumerable: true, get: function () { return property_value_set_1.toString; } });
Object.defineProperty(exports, "toStringInSpecifiedOrder", { enumerable: true, get: function () { return property_value_set_1.toStringInSpecifiedOrder; } });
const equals = (a, b) => property_1.PropertyValueSet.equals(a, b, PropertyCompare.compare);
exports.equals = equals;
function fromString(encodedValueSet) {
    return property_1.PropertyValueSet.fromString(encodedValueSet, uom_1.unitLookup);
}
function fromStringOrError(onError, encodedValueSet) {
    return property_1.PropertyValueSet.fromStringOrError(onError, encodedValueSet, uom_1.unitLookup);
}
//# sourceMappingURL=property-value-set.js.map